import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

function ProtectedRoute({ children }) {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );
  const [loading, setLoading] = useState(location.state?.user ? false : true);

  useEffect(() => {
    if (location.state?.user) {
      return;
    }

    // Check localStorage first as fallback
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        if (user && user.user_id) {
          setIsAuthenticated(true);
          setLoading(false);
          return;
        }
      } catch (e) {}
    }

    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('access_token');
          const response = await fetch(`${API}/auth/me`, {
            headers: token ? { 'Authorization': `Bearer ${token}` } : {},
          credentials: 'include',
        });
        const data = await response.json();
        if (response.ok && data && data.user_id) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (err) {
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [location.state]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
